export default "__VITE_ASSET__c6190680__"